const CACHE_KEY = 'kaapAdGroupsCache';
const CACHE_TTL_KEY = 'kaapAdGroupsCacheTTL';
const CACHE_TTL = 30 * 24 * 60 * 60 * 1000;

interface CacheData {
  groups: Record<string, string>;
}

const checkAndClearExpiredCache = (): boolean => {
  try {
    const expiryStr = localStorage.getItem(CACHE_TTL_KEY);
    if (!expiryStr) return false;

    const expiry = parseInt(expiryStr, 10);
    const now = Date.now();

    if (now > expiry) {
      localStorage.removeItem(CACHE_KEY);
      localStorage.removeItem(CACHE_TTL_KEY);
      return false;
    }

    return true;
  } catch {
    return false;
  }
};

const getCachedGroups = (): Map<string, string> => {
  try {
    const cachedData = localStorage.getItem(CACHE_KEY);
    if (!cachedData) {
      return new Map<string, string>();
    }

    const data: CacheData = JSON.parse(cachedData);
    return new Map(Object.entries(data.groups));
  } catch {
    return new Map<string, string>();
  }
};

const setCachedGroups = (groups: Map<string, string>): void => {
  try {
    let existingGroups: Record<string, string> = {};

    const cachedData = localStorage.getItem(CACHE_KEY);
    if (cachedData) {
      const data: CacheData = JSON.parse(cachedData);
      existingGroups = data.groups;
    }

    for (const [groupId, groupName] of groups.entries()) {
      existingGroups[groupId] = groupName;
    }

    const newData: CacheData = {
      groups: existingGroups,
    };
    const expiryDate = Date.now() + CACHE_TTL;

    localStorage.setItem(CACHE_KEY, JSON.stringify(newData));
    localStorage.setItem(CACHE_TTL_KEY, expiryDate.toString());
  } catch {
    // Silently fail if localStorage is not available
  }
};

export { getCachedGroups, setCachedGroups, checkAndClearExpiredCache };
